import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_number_input = _resolveComponent("v-number-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_ScheduledRunHistoryDialog = _resolveComponent("ScheduledRunHistoryDialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "ma-0 pa-2 card",
    color: "background",
    density: "compact",
    variant: "elevated",
    elevation: "4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        ref: "formRef",
        density: "compact",
        onSubmit: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_item, {
                key: 0,
                class: "schedule-summary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = true))
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_avatar, {
                    size: "40",
                    rounded: "lg",
                    class: "mr-3 schedule-summary-avatar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-calendar-clock-outline",
                        size: "small"
                      })
                    ]),
                    _: 1
                  })
                ]),
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    icon: "mdi-chevron-down",
                    size: "small",
                    variant: "plain",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.show = true), ["stop"]))
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-truncate" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.label || _ctx.agentName || 'New Schedule'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_subtitle, { class: "text-truncate" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.scheduleSubtitle), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 1,
                class: "pt-0 pb-2 schedule-summary-text"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_chip, {
                      class: "mr-2 mb-2",
                      color: _ctx.status === 'enabled' ? 'success' : 'grey',
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.status), 1)
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    (_ctx.nextRunLabel)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          class: "mr-2 mb-2",
                          size: "small",
                          variant: "tonal"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Next " + _toDisplayString(_ctx.nextRunLabel), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.lastRunLabel)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 1,
                          class: "mr-2 mb-2",
                          size: "small",
                          variant: "outlined"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Last " + _toDisplayString(_ctx.lastRunLabel), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_v_list, { class: "bg-background" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.agentName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.agentName) = $event)),
                        items: _ctx.agentNames,
                        label: "Agent to Run",
                        variant: "outlined",
                        density: "compact",
                        rules: [v => !!v || 'Agent is required'],
                        class: "pt-2"
                      }, null, 8, ["modelValue", "items", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.label,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.label) = $event)),
                        label: "Label",
                        variant: "outlined",
                        density: "compact",
                        placeholder: "e.g. Daily news summary",
                        hint: "A descriptive name for this schedule",
                        "persistent-hint": "",
                        class: "pt-2",
                        maxlength: "120",
                        counter: "",
                        rules: _ctx.labelRules
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_textarea, {
                        modelValue: _ctx.prompt,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.prompt) = $event)),
                        label: "Prompt",
                        variant: "outlined",
                        density: "compact",
                        rules: [v => !!v || 'Prompt is required'],
                        class: "pt-2"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        "model-value": _ctx.formattedStartDate,
                        label: "Start Date",
                        variant: "outlined",
                        density: "compact",
                        readonly: "",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showStartDateDialog = true)),
                        class: "pt-2"
                      }, null, 8, ["model-value"]),
                      _createVNode(_component_v_dialog, {
                        modelValue: _ctx.showStartDateDialog,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showStartDateDialog) = $event)),
                        "max-width": "300px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_date_picker, {
                            modelValue: _ctx.startDate,
                            "onUpdate:modelValue": [
                              _cache[6] || (_cache[6] = ($event: any) => ((_ctx.startDate) = $event)),
                              _cache[7] || (_cache[7] = ($event: any) => (_ctx.showStartDateDialog = false))
                            ]
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.repeatInterval,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.repeatInterval) = $event)),
                        items: ['daily', 'weekly', 'monthly', 'once'],
                        label: "Frequency",
                        variant: "outlined",
                        density: "compact",
                        class: "pt-2"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item_title, { class: "pl-4 text-caption" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Times to Run (" + _toDisplayString(_ctx.userTimezone) + ")", 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localTimesToRun, (time, index) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          align: "center",
                          class: "py-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "4",
                              class: "py-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_number_input, {
                                  modelValue: time.hour,
                                  "onUpdate:modelValue": ($event: any) => ((time.hour) = $event),
                                  label: "Hour",
                                  min: 1,
                                  max: 12,
                                  "control-variant": "stacked",
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  class: "pt-3 pb-2"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, {
                              cols: "4",
                              class: "py-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_number_input, {
                                  modelValue: time.minute,
                                  "onUpdate:modelValue": ($event: any) => ((time.minute) = $event),
                                  label: "Minute",
                                  min: 0,
                                  max: 59,
                                  "control-variant": "stacked",
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  class: "pt-3 pb-2"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, {
                              cols: "3",
                              class: "py-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  modelValue: time.ampm,
                                  "onUpdate:modelValue": ($event: any) => ((time.ampm) = $event),
                                  items: ['AM', 'PM'],
                                  density: "compact",
                                  "hide-details": "",
                                  variant: "outlined",
                                  class: "pt-3 pb-2"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "py-0"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.localTimesToRun.length > 1)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      icon: "mdi-minus-circle",
                                      variant: "text",
                                      onClick: ($event: any) => (_ctx.removeTime(index))
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        onClick: _ctx.addTime,
                        size: "small",
                        "prepend-icon": "mdi-plus"
                      }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode("Add Time")
                        ])),
                        _: 1,
                        __: [18]
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  (_ctx.repeatInterval === 'weekly')
                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.daysOfWeek,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.daysOfWeek) = $event)),
                            items: _ctx.weekdays,
                            "item-title": "title",
                            "item-value": "value",
                            label: "Days of Week",
                            multiple: "",
                            chips: "",
                            variant: "outlined",
                            density: "compact"
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.repeatInterval === 'monthly')
                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_number_input, {
                            modelValue: _ctx.dayOfMonth,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dayOfMonth) = $event)),
                            label: "Day of Month",
                            min: 1,
                            max: 31,
                            "control-variant": "stacked"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_checkbox, {
                        modelValue: _ctx.sendEmail,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.sendEmail) = $event)),
                        label: `Send result to: ${_ctx.email}`,
                        "hide-details": ""
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.show]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              (_ctx.show)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    color: "primary",
                    click: _ctx.saveSchedule,
                    icon: "mdi-check-bold",
                    tooltip: "Save",
                    size: "large"
                  }, null, 8, ["click"]))
                : _createCommentVNode("", true),
              (_ctx.show && !_ctx.isNew)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    color: "primary",
                    click: _ctx.initiateDelete,
                    icon: "mdi-trash-can-outline",
                    tooltip: "Delete",
                    size: "large"
                  }, null, 8, ["click"]))
                : _createCommentVNode("", true),
              (_ctx.show && !_ctx.isNew)
                ? (_openBlock(), _createBlock(_component_v_switch, {
                    key: 2,
                    modelValue: _ctx.enabled,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.enabled) = $event)),
                    onChange: _ctx.toggleStatus,
                    label: _ctx.status,
                    color: "primary",
                    "hide-details": "",
                    inset: ""
                  }, null, 8, ["modelValue", "onChange", "label"]))
                : _createCommentVNode("", true),
              (_ctx.show && !_ctx.isNew)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 3,
                    color: "primary",
                    click: _ctx.openHistoryDialog,
                    icon: "mdi-history",
                    tooltip: "View History",
                    size: "large"
                  }, null, 8, ["click"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: _ctx.show ? 'mdi-chevron-up' : 'mdi-chevron-down',
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.show = !_ctx.show))
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      _createVNode(_component_ConfirmationDialog, {
        modelValue: _ctx.showDeleteDialog,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showDeleteDialog) = $event)),
        title: "Confirm Deletion",
        message: "Are you sure you want to delete this schedule?",
        onConfirm: _ctx.confirmDelete
      }, null, 8, ["modelValue", "onConfirm"]),
      _createVNode(_component_ScheduledRunHistoryDialog, {
        "run-id": _ctx.runId,
        show: _ctx.showHistoryDialog,
        modelValue: _ctx.showHistoryDialog,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showHistoryDialog) = $event))
      }, null, 8, ["run-id", "show", "modelValue"])
    ]),
    _: 1
  }))
}